var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","type":"text"}},[_vm._v(_vm._s(_vm.getName()))])
}
var staticRenderFns = []

export { render, staticRenderFns }